import React from 'react'
import ProductDetails from './ProductDetails'
import Navbar from '../Home/Navbar'
import Footer from '../Home/Footer'
import AuthModal from '../Auth/AuthModal.jsx'
import ProductOffer from './ProductOffer.jsx'
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from "react-router-dom";


function ProductMain({selectedArea, setSelectedArea , isLoggedIn, setIsLoggedIn , setShowAuthModal , showAuthModal }) {
  const navigate = useNavigate();
  return (
    <div className='min-h-screen flex flex-col'>
      {/* Top nav */}
      <Navbar
        selectedArea={selectedArea}
        setSelectedArea={setSelectedArea}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        onLoginClick={() => setShowAuthModal(true)}
      />
      <div className='max-w-6xl p-6'>
      <button onClick={() => navigate(`/`)}>
        <ArrowLeft size={20} />
      </button>
      </div>
      {/* Product Details Component */}
      <div className='flex-1'>
      <ProductDetails 
      isLoggedIn={isLoggedIn}
      />
      {/* <ProductOffer 
      isLoggedIn={isLoggedIn}
      /> */}
      </div>

      {showAuthModal && (
        <AuthModal
          onClose={() => setShowAuthModal(false)}
          setIsLoggedIn={setIsLoggedIn}
        />
      )}
      <Footer/>
    </div>
  )
}

export default ProductMain
